import React from 'react'
import { render } from 'react-dom'
import store from 'redux/store'
import history from 'helpers/history'
import {
	Router as Router,
} from 'react-router-dom'
import App from 'views/app'
import { Provider as ReduxProvider } from 'react-redux'
import { DragDropContextProvider } from 'react-dnd'
import * as Sentry from '@sentry/react'

import MultiBackend, { Preview } from 'react-dnd-multi-backend'
import HTML5toTouch from 'react-dnd-multi-backend/lib/HTML5toTouch'
import objectAssign from 'object-assign'

import DragAndDropTypes from 'helpers/enums/dragAndDropTypes'
import QuizQuestionDrag from 'components/question/drag/question_drag'
import QuizAnswerDrag from 'components/answer/drag/answer_drag'
import { localize } from 'helpers/translator'

import 'helpers/sentry'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import 'scss/fonts.scss'

function generatePreview(type, item, style) {
	objectAssign(style, {zIndex: 1010})
	switch (type) {
		case DragAndDropTypes.QUIZ_QUESTIONS:
			return (
				<div style={style}>
					<QuizQuestionDrag questionId={item.questionId} title={item.title} />
				</div>
			)
		case DragAndDropTypes.QUIZ_ANSWERS:
			objectAssign(style, {position: 'absolute'})
			return (
				<div style={style}>
					<QuizAnswerDrag answerId={item.answerId} value={item.value} checked={item.checked} />
				</div>
			)
		default:
			return (
				<div></div>
			)
	}
}

render(
	<Sentry.ErrorBoundary fallback={localize('global_error')}>
		<DragDropContextProvider backend={MultiBackend(HTML5toTouch)}>
			<div className="react_base">
				<Preview generator={generatePreview} />
				<ReduxProvider store={store}>
					<Router history={history}>
						<App/>
					</Router>
				</ReduxProvider>
			</div>
		</DragDropContextProvider>
	</Sentry.ErrorBoundary>,
	document.getElementById('app')
)
